import React from "react";
import { makeStyles } from "@material-ui/styles";
import { FormControlLabel, MenuItem, Select } from "@material-ui/core";
import styles from "styles/admin-search.module.scss";
import {
  IDENTIFIED_STATE,
  LINE_CHAT_AVAILABILITY,
  FEE_CATEGORY,
  CANCELLATION_CATEGORY,
} from "const";
import { StatusSelectField } from "./StatusSelectField";

const useStyles = makeStyles(() => ({
  searchItem: {
    color: "#757575",
  },
}));

// NOTE: Search.jsで定義されているstateに型情報がないためanyにしている
// TODO: stateに型がついたら更新する
type Props = {
  identification: {
    state: any;
    action: (e: any) => void;
  };
  fee: {
    state: any;
    action: (e: any) => void;
  };
  cancellation: {
    state: any;
    action: (e: any) => void;
  };
  line: {
    state: any;
    action: (e: any) => void;
  };
};

type Selections = {
  label: string;
  labelPlacement?: "bottom" | "top" | "end" | "start" | undefined;
  state: any;
  action: (e: any) => void;
  options: ReadonlyArray<{label: string, value: any}>;
};

/**
 * ステータスに関する検索条件をまとめたコンポーネント
 * @param props stateとその更新関数の組み合わせ
 */
const StatusSelectGroup: React.FC<Props> = (props) => {
  const { identification, fee, cancellation, line } = props;
  const classes = useStyles();

  const SELECTIONS: Selections[] = [
    { label: "フィー区分", options: FEE_CATEGORY, ...fee },
    { label: "解約区分", options: CANCELLATION_CATEGORY, ...cancellation },
    { label: "LINE", options: LINE_CHAT_AVAILABILITY, ...line },
  ];

  return (
    <>
      {/* NOTE: 他の選択項目と作りが違うためそのまま */}
      <FormControlLabel
        className={classes.searchItem}
        control={
          <Select
            className={styles.searchConditionSelectBox}
            value={identification.state || ""}
            onChange={(event) => identification.action(event.target.value)}
          >
            <MenuItem value={0}>&nbsp;</MenuItem>
            <MenuItem value={IDENTIFIED_STATE.UNIDENTIFIED.VALUE}>
              {IDENTIFIED_STATE.UNIDENTIFIED.LABEL}
            </MenuItem>
            <MenuItem value={IDENTIFIED_STATE.OK.VALUE}>
              {IDENTIFIED_STATE.OK.LABEL}
            </MenuItem>
            <MenuItem value={IDENTIFIED_STATE.NG.VALUE}>
              <span className={styles.identifiedNgText}>
                {IDENTIFIED_STATE.NG.LABEL}
              </span>
            </MenuItem>
          </Select>
        }
        label="本人確認"
        labelPlacement="start"
      />

      {SELECTIONS.map(({ label, labelPlacement, options, state, action }) => {
        return (
          <FormControlLabel
            key={label}
            className={classes.searchItem}
            control={
              <StatusSelectField
                state={state}
                action={action}
                options={options}
                key={label}
              />
            }
            label={label}
            labelPlacement={labelPlacement || "start"}
          />
        );
      })}
    </>
  );
};

export { StatusSelectGroup };
